import React, { useContext, useState } from 'react'
import AccountInformationCard from '../../../../utility/accountInformationCard';
import { useNavigate } from 'react-router-dom';
import { deleteMetaIntegrationPayload, metaIntegrationFaceBookDataNew, metaIntegrationPhoneNumberDataModel, metaIntegrationPhoneNumberDataNew, metaIntegrationWhatsAppDataNew, metIntegrationInstagramDataNew } from '../../../../../models/axiosModel';
import { IntegrationContext, IntegrationContextPayload } from '../../../../../context/integrationContext';
import GlobalDeletePopup from '../../../../utility/globalDeletePopup/globalDeletePopup';
import agent from '../../../../../services/api';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import { toCapitalizedCase } from '../../../../../utils/constants';
import { Grid } from '@mui/material';
import { channel } from 'node:diagnostics_channel';
import { useGenericStore } from '../../../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';


interface checkFlag {
    flagPhone?: boolean
}
function IntegrationDetails(props: checkFlag) {
    const navigate = useNavigate()
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload
    const { integrationDetails, globalIntegrationTypeList } = useContext(IntegrationContext) as IntegrationContextPayload
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState<boolean>(false);    

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const deleteMetaIntegration = async () => {
        if (integrationDetails && globalIntegrationTypeList) {
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))

            const payload = {
                channel_id: globalIntegrationTypeList.find((type) => type.channel_name.toLowerCase() == "whatsapp")?.channel_id || 1,
                meta_integration_whatsapp_id: (integrationDetails.integrated_channel_id) as number,
            }
            const response = await agent.deleteMetaIntegration.delete(payload);
            if (response.status) {
                showSuccess("Integration deleted Successfully!")
                navigate('/channels')
            } else {
                handleError(response);
            }
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
        }
    }

    const formatMessagingLimit = (limit?: string) => {
        if(!limit) return "-";
        if(limit === "UNLIMITED") return "Unlimited";

        const limitInStr = limit?.replace("TIER_", "");

        const limitInNumber = limitInStr?.includes("K") ? Number(limitInStr.replace("K", "")) * 1000 : Number(limitInStr);

        return limitInNumber?.toLocaleString();
    }
    
    return (
        <>
            {integrationDetails !== null && !props.flagPhone &&
                <AccountInformationCard
                    key={integrationDetails.meta_integration_whatsapp_id}
                    flagDelete={true}
                    title={"Meta"}
                    flagShowMetaIcon={true}
                    currentlySelected={false}
                    details={{
                        waba_id: integrationDetails.waba_id,
                        verified_name: integrationDetails?.waba_name ?? 'WhatsApp Business Account',
                        business_verification_status: integrationDetails?.business_verification_status ? toCapitalizedCase(integrationDetails?.business_verification_status) : "-",
                        waba_account_status: integrationDetails?.waba_account_status ? toCapitalizedCase(integrationDetails?.waba_account_status) : "-",
                        whatsapp_messaging_limit: formatMessagingLimit(integrationDetails?.whatsapp_business_manager_messaging_limit),
                        catalog: integrationDetails?.catalog_id ? `${integrationDetails?.catalog_name} | ${integrationDetails?.catalog_id}` : 'N/A'
                        // meta_business_id: "419089917245626"
                    }}
                    deleteChatbotIntegration={() => { setShowDeleteConfirmation(true) }}
                />
            }
            {integrationDetails !== null && props.flagPhone && integrationDetails.meta_integration_phone_number_data.length > 0 && integrationDetails.meta_integration_phone_number_data.map((integration: metaIntegrationPhoneNumberDataNew, index: number) => {
                return <Grid item key={index}>
                    <AccountInformationCard
                        flagShowLinkedChatbot 
                        flagShowCustomRecipient
                        key={index}
                        flagDelete={false}
                        title={`WhatsApp Account ${index + 1}`}
                        currentlySelected={integration.chatbot_integration_assignment_data.length > 0}
                        // currentlySelected={false}
                        details={{
                            display_phone_number: integration.display_phone_number,
                            integrated_channel_id: String(integration.integrated_channel_id),
                            quality_rating: integration.quality_rating,
                            phone_number_id: integration.phone_number_id,
                            linked_chatbots: integration.chatbot_integration_assignment_data?.filter((chatbot) => !(chatbot.is_workflow_chatbot)), 
                            linked_workflows: integration.chatbot_integration_assignment_data?.filter((chatbot) => chatbot.is_workflow_chatbot),
                            business_name: integration.verified_name,
                            meta_integration_whatsapp_phone_number_id: integration?.meta_integration_whatsapp_phone_number_id,
                            flag_send_agent_activity_message: integration?.flag_send_agent_activity_message,
                            agent_activity_message: integration?.agent_activity_message,
                            flag_disable_agent_on_user_inactivity: integration?.flag_disable_agent_on_user_inactivity,
                            time_of_inactivity_in_ms: integration?.time_of_inactivity_in_ms,
                            flag_smb_phone_number: integration?.flag_smb_phone_number,
                            flag_agent_assignment_on_smb_message: integration?.flag_agent_assignment_on_smb_message
                        }} />
                </Grid>
            })}
            {showDeleteConfirmation &&
                <GlobalDeletePopup
                    deleteDescription={`Are you sure you want to delete this Integration`}
                    open={showDeleteConfirmation}
                    onClose={() => { setShowDeleteConfirmation(false) }}
                    onDelete={() => {
                        deleteMetaIntegration()
                        setShowDeleteConfirmation(false)
                    }}
                />
            }
        </>

    )
}

export default IntegrationDetails